export const checkFeatureEnabled = (
  featureFlags: { [featureName: string]: string[] },
  featureName: string,
  userId: string,
) => {
  const featureUsers = featureFlags?.[featureName] || [];
  return featureUsers.includes(userId);
};
